import * as React from 'react';
import { SVGProps } from 'react';
export const ThumbUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden={true}
    focusable={false}
    {...props}
  >
    <path
      d="M6 23H1V12h5M6 12 9 1a3 3 0 0 1 3 3v6h7.5a3 3 0 0 1 2.965 3.456l-1.077 7A3 3 0 0 1 18.426 23H6V12Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
